import { fromZonedTime } from 'date-fns-tz';

/**
 * Adjust a Date to fall outside of break windows
 * If time falls within a break, push it to the end of the break
 */
// M-2: Exported for client-side preview break adjustment in handleDragOver
export function adjustForBreaks(time: Date, breaks: any[], dateStr: string, timezone: string): Date {
  let adjustedTime = new Date(time);
  let iterations = 0;
  const MAX_ITERATIONS = 10;

  while (iterations < MAX_ITERATIONS) {
    let isInBreak = false;

    for (const brk of breaks) {
      // Parse break times in shop timezone
      const breakStart = fromZonedTime(`${dateStr} ${brk.start}`, timezone);
      const breakEnd = fromZonedTime(`${dateStr} ${brk.end}`, timezone);

      if (adjustedTime >= breakStart && adjustedTime < breakEnd) {
        adjustedTime = new Date(breakEnd);
        isInBreak = true;
        break;
      }
    }

    if (!isInBreak) break;
    iterations++;
  }

  return adjustedTime;
}
